import {FieldRequiredIndicator} from '../../components/form/field-required-indicator.js'
import {useFieldContext} from '../../integrations/form/index.js'
import {Field, Input, InputGroup, InputGroupProps, InputProps} from '@chakra-ui/react'
import {ErrorMessage} from './error-message.js'
import {FieldRoot} from './field-root.js'
import {forwardRef, ReactNode} from 'react'

export interface FieldProps extends InputProps {
  label: ReactNode
  required?: boolean
  hideLabel?: boolean
  disabled?: boolean
  placeholder?: string
  helpText?: string
  //! create custom input fields for other types
  type?: 'text' | 'email' | 'tel' | 'url'
  inputGroupProps?: Omit<InputGroupProps, 'children'>
}

export const TextField = forwardRef<HTMLInputElement, FieldProps>(function TextField(
  {required, hideLabel, inputGroupProps, ...props},
  ref
) {
  const field = useFieldContext<string>()
  return (
    <FieldRoot required={required} disabled={props.disabled}>
      <Field.Label srOnly={Boolean(hideLabel)}>
        {props.label}
        {required && <FieldRequiredIndicator />}
      </Field.Label>
      <InputGroup {...inputGroupProps}>
        <Input
          ref={ref}
          backgroundColor="bg"
          name={field.name}
          placeholder={props.placeholder}
          value={field.state.value}
          onChange={e => field.handleChange(e.target.value)}
          onBlur={() => field.handleBlur()}
          {...props}
        />
      </InputGroup>
      {props.helpText && <Field.HelperText>{props.helpText}</Field.HelperText>}
      <ErrorMessage />
    </FieldRoot>
  )
})
